import React, { useEffect, useState } from "react";
import { Image, Select } from "antd";
import { FormGroup, Input, Button, Form, Col, Row } from "reactstrap";
import Resizer from "react-image-file-resizer";

const { Option } = Select;
const AddProductPackage = ({
  colour,
  setcolour,
  price,
  setprice,
  mrp,
  setmrp,
  setimage,
  thumbnail,
  setThumbnail,
  size,
  setSize,
  quantities: propQuantities, // parent se quantities prop lete hain (rename to avoid conflict)
  setQuantities: propSetQuantities, // parent se setter function
  addvariant, // add button click par call hone wala handler
  statusupdate, // true => update mode, false => add mode
  updatevariant, // update button handler
}) => {
  // Toggle flag for showing local image preview (file vs URL)
  const [toggle, setToggle] = useState(false);

  // Agar parent ne quantities pass nahi ki, to local state use karo
  const [localQuantities, setLocalQuantities] = useState({});
  const quantities = propQuantities || localQuantities;
  const setQuantities = propSetQuantities || setLocalQuantities;

  // 📸 File select hone par image resize & preview handle karta hai
  const fileHandler = (e) => {
    const file = [...e.target.files];
    if (file) {
      setToggle(true);
      setimage([]); // reset previous images
      setThumbnail([]); // reset previous thumbnails

      // Resize each selected image
      file.forEach((file) => {
        Resizer.imageFileResizer(
          file,
          500, // width
          500, // height
          "JPEG", // output format
          90, // quality
          0, // rotation
          (uri) => {
            // store resized images
            setimage((prev) => [...prev, uri]);
            setThumbnail((prev) => [...prev, uri]);
          },
          "file",
          500,
          500
        );
      });
    } else {
      // reset if no image selected
      setimage(null);
      setThumbnail(null);
    }
  };

  // 🧹 toggle reset kar deta hai agar thumbnail null ho jaye
  useEffect(() => {
    if (thumbnail == null) {
      setToggle(false);
    }
  }, [thumbnail]);

  // 🧩 Size select karte waqt quantities sync karta hai
  const handleSizeChange = (val) => {
    setSize(val);

    // agar naye size add hue to unke liye default 0 quantity
    // aur jo remove hue unhe delete kar do
    setQuantities((prev) => {
      const newQuantities = { ...prev };
      val.forEach((s) => {
        if (!(s in newQuantities)) {
          newQuantities[s] = 0;
        }
      });
      Object.keys(newQuantities).forEach((key) => {
        if (!val.includes(key)) {
          delete newQuantities[key];
        }
      });
      return newQuantities;
    });
  };

  // 🧮 Quantity input change handler
  const handleQuantityChange = (sizeKey, value) => {
    setQuantities((prev) => ({
      ...prev,
      [sizeKey]: parseInt(value) || 0,
    }));
  };

  // ➕ Add Variant button click handler
  const handleAddVariant = () => {
    addvariant({ sizesWithQuantities: { ...quantities } });
  };

  // 🔁 Update Variant button click handler
  const handleUpdateVariant = () => {
    updatevariant({ sizesWithQuantities: { ...quantities } });
  };

  return (
    <>
      <Form role="form">
        {/* 🎨 Colour picker */}
        <FormGroup>
          <label className="form-control-label" htmlFor="title">
            Select Colour
          </label>
          <Input
            className="form-control-alternative"
            id="title"
            placeholder="Enter Title"
            type="color"
            value={colour}
            onChange={(e) => setcolour(e.target.value)}
          />
        </FormGroup>

        {/* 🖼️ Image upload and preview */}
        <FormGroup>
          <label className="form-control-label" htmlFor="image">
            Image
          </label>
          <Input
            className="form-control-alternative"
            id="image"
            type="file"
            accept="image/*"
            onChange={fileHandler}
            multiple
          />
          <Row>
            {/* Server images (already uploaded) */}
            {!toggle &&
              thumbnail &&
              thumbnail.map((item, index) => (
                <Col lg="3" key={index} className="mt-3">
                  <Image src={`${item.image}`} className="img-fluid" alt="default" />
                </Col>
              ))}

            {/* Local preview (before upload) */}
            {toggle &&
              thumbnail &&
              thumbnail.map((item, index) => (
                <Col lg="3" key={index} className="mt-3">
                  <Image src={URL.createObjectURL(item)} className="img-fluid" alt="banner" />
                </Col>
              ))}
          </Row>
        </FormGroup>

        {/* 📏 Size selection */}
        <FormGroup>
          <label className="form-control-label" htmlFor="size">
            Select Size
          </label>
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Enter or Select Size"
            value={size}
            onChange={(val) => setSize(val)} // ✅ no duplicates
          >
            <Option value="sm">sm</Option>
            <Option value="md">md</Option>
            <Option value="lg">lg</Option>
            <Option value="xl">xl</Option>
            <Option value="xxl">xxl</Option>
            <Option value="xxxl">xxxl</Option>
          </Select>
        </FormGroup>

        {/* 📦 Quantity input for each selected size */}
        {size && size.length > 0 && (
          <FormGroup>
            <label className="form-control-label">Quantities for Selected Sizes</label>
            <Row>
              {size.map((s, index) => (
                <Col md={6} key={index} className="mb-2">
                  <label className="form-control-label mb-1" htmlFor={`qty-${s}`}>
                    Quantity for {s}:
                  </label>
                  <Input
                    type="number"
                    value={quantities[s] || 0}
                    onChange={(e) =>
                      setQuantities((prev) => ({
                        ...prev,
                        [s]: parseInt(e.target.value) || 0,
                      }))
                    }
                  />
                </Col>
              ))}
            </Row>
          </FormGroup>
        )}

        {/* 💰 Price input */}
        <FormGroup>
          <label className="form-control-label" htmlFor="price">
            Enter Price
          </label>
          <Input
            className="form-control-alternative"
            id="price"
            placeholder="Enter Price"
            type="number"
            value={price}
            onChange={(e) => setprice(e.target.value)}
          />
        </FormGroup>

        {/* 🏷️ MRP input */}
        <FormGroup>
          <label className="form-control-label" htmlFor="mrp">
            Enter Mrp
          </label>
          <Input
            className="form-control-alternative"
            id="mrp"
            placeholder="Enter Mrp"
            type="number"
            value={mrp}
            onChange={(e) => setmrp(e.target.value)}
          />
        </FormGroup>

        {/* 🧲 Add / Update button */}
        {statusupdate ? (
          <Button
            className="my-4 btn-block"
            type="submit"
            color="primary"
            onClick={updatevariant}
          >
            Update Variant
          </Button>
        ) : (
          <Button
            className="my-4 btn-block"
            type="submit"
            color="primary"
            onClick={addvariant}
          >
            Add Variant
          </Button>
        )}
      </Form>
    </>
  );
};

export default AddProductPackage;
